/**
 * Module dependencies.
 */

/**
 * `SocialNetworks` type.
 */

export type SocialNetworks = Record<string, string>;

/**
 * Export `pickSocialNetworks`.
 *
 * As redes sociais viviam numa coleccao propria (`socialNetworks`), que foi
 * fundida em `Company` para reduzir o numero de coleccoes do Directus -- o
 * tier Core do Directus 12 limita a 25 e estavamos em 28.
 *
 * O formato devolvido mantem-se igual ao que a coleccao antiga dava, para os
 * consumidores (o Footer) nao terem de mudar.
 */

export function pickSocialNetworks(company: any): SocialNetworks {
  return {
    facebook: company?.facebook,
    instagram: company?.instagram,
    linkedin: company?.linkedin,
    pinterest: company?.pinterest,
    twitter: company?.twitter,
    youtube: company?.youtube,
  };
}
